import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Reinsurance } from './Reinsurance';

export const ReinsuranceDesktop: FunctionComponent = () => {
  return (
    <StyledSection>
      <Reinsurance />
    </StyledSection>
  );
};

const StyledSection = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  z-index: 1;

  display: block;
  @media (max-width: 1024px) {
    display: none;
  }
`;
